module.exports = __webpack_public_path__ + "static/media/logo-expodireto.f6fdddad.png";